module.exports = __webpack_public_path__ + "img/pt_Ecran 1.7823ea96.png";